import { OutilWrapper } from "./Outil.style";
import { useEffect } from "react";
import Aos from "aos";
import HeaderOutil from "../../components/outil/HeaderOutil/HeaderOutil";
import Footer from "../../components/global/Footer/Footer";
import { Button } from "antd";
import Link from "next/link";
import { useMediaQuery } from "react-responsive";
import { NextSeo } from "next-seo";
import Bloc from "../../components/Bloc/Bloc";
import ajouter_patrimoine from "../../../public/outil/ajouter_patrimoine.webp";
import suivre_patrimoine from "../../../public/outil/suivre_patrimoine.png";
import decider_en_connaissance from "../../../public/outil/decider_en_connaissance.png";

export default function Outil() {
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <OutilWrapper>
      <NextSeo
        title={
          "Le seul agrégateur du marché qui vous apporte un conseil personnalisé !"
        }
        description={
          "Une vision globale de votre patrimoine.\nDes conseils adaptés à votre situation.\nDes propositions personnalisées rien que pour vous !"
        }
      />
      <HeaderOutil isDesktop={isDesktop} />
      <Bloc
        title={<h2 className="title">Ajouter mon patrimoine</h2>}
        btn={"Ajouter mon patrimoine"}
        img={ajouter_patrimoine}
        isDesktop={isDesktop}
      >
        Ajoutez facilement toute votre situation famliale mais aussi vos{" "}
        <strong>biens financiers</strong> et immobiliers. Notre outil gère tous
        les <strong>placements</strong> existants et tous les biens immobiliers.
      </Bloc>
      <Bloc
        title={<h2 className="title">Suivre tout votre patrimoine</h2>}
        btn={"Suivre mon patrimoine"}
        img={suivre_patrimoine}
        isDesktop={isDesktop}
        reverse
      >
        Suivez l'évolution de vos <strong>actifs immobiliers</strong> et
        financiers pour avoir une vision globale et des projections futurs vous
        permettant d'agir.
        <strong> Optimisez votre patrimoine</strong>.
      </Bloc>
      <Bloc
        title={<h2 className="title">Simuler et décider en connaissance</h2>}
        btn={"Démarrer les simulations"}
        img={decider_en_connaissance}
        isDesktop={isDesktop}
      >
        Chaque jour, vos supports sont étudiés pour définir s'ils sont toujours
        <strong> adaptés, diversifiés et optimisés</strong>. Nous vous aidons
        aussi à simuler la
        <strong> rentabilité de vos futurs placements</strong>.
      </Bloc>

      <div className="relation">
        <div className="title">
          La relation client au coeur de l'outil d'aide à la décision !
        </div>
        <div className="content">
          Avoir une vision globale, c'est bien. Mais pouvoir en discuter avec un
          conseiller dédié, c'est encore mieux. Chez Easy Capital, nous pensons
          qu'il est important de vous donner accés à un outil permettant de
          mieux comprendre votre situation. Pour autant, nous pouvons vous
          accompagner dans vos futurs décisions afin que celles-ci soient les
          plus adaptées à vos attentes.
        </div>
        <Button>
          <Link href="/start">Commencer à gérer avec un conseiller</Link>
        </Button>
      </div>
      <Footer />
    </OutilWrapper>
  );
}
